import { render } from "./ProfaceWingReport.vue?vue&type=template&id=72c88314&scoped=true"
import script from "./ProfaceWingReport.vue?vue&type=script&lang=js"
export * from "./ProfaceWingReport.vue?vue&type=script&lang=js"

import "./ProfaceWingReport.vue?vue&type=style&index=0&id=72c88314&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c88314"]])

export default __exports__